// extracted by mini-css-extract-plugin
export var addToCart = "product-card-module--addToCart--af540";
export var free4uImg = "product-card-module--free4uImg--a727c";
export var gatsbyImageWrapper = "product-card-module--gatsbyImageWrapper--b5736";
export var onSaleRibbon = "product-card-module--onSaleRibbon--67b6b";
export var productCardBody = "product-card-module--productCardBody--9e761";
export var productCardStyle = "product-card-module--productCardStyle--a9c98";
export var productDetailsStyle = "product-card-module--productDetailsStyle--9d99e";
export var productHeadingStyle = "product-card-module--productHeadingStyle--debbd";
export var productImageStyle = "product-card-module--productImageStyle--5f8c8";
export var productInfo = "product-card-module--productInfo--34c66";
export var productPrice = "product-card-module--productPrice--ae540";
export var quickBuy = "product-card-module--quickBuy--4144a";
export var savings = "product-card-module--savings--d870f";
export var search_suggestions = "search-bar-module--search_suggestions--1351f";
export var shippingIcon = "product-card-module--shippingIcon--664c6";
export var strikeThrough = "product-card-module--strikeThrough--89249";